/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { Table, Typography, Button, Badge } from "antd";
import ParticularCandidates from "../../onboarding/particularcandidates/ParticularCandidates";
const { Text } = Typography;

const TABS = [
    { key: "Pending", label: "Pending", activeColor: "#faad14" },
    { key: "Approved", label: "Approved", activeColor: "#4CAF50" },
    { key: "Rejected", label: "Rejected", activeColor: "#f5222d" },
];

export default function VerifiedCandidates() {
    const { authData, backUrl } = useContext(AuthContext);
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("Pending");
    const [tabCounts, setTabCounts] = useState({ Pending: 0, Approved: 0, Rejected: 0 });
    const [showParticular, setShowParticular] = useState({
        show: false,
        cid: 0,
    });

    const fetchCandidates = async (status) => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/hr-review-list/?status=${status}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setCandidates(res.data.results || res.data);
        } catch (err) {
            console.error("Error fetching verified candidates:", err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch counts for all three tab badges
    const fetchTabCounts = async () => {
        try {
            const results = await Promise.all(
                TABS.map((tab) =>
                    axios.get(
                        `${backUrl}/api/emp/hr-review-list/?status=${tab.key}`,
                        { headers: { Authorization: `Bearer ${authData?.access}` } }
                    )
                )
            );
            const counts = {};
            TABS.forEach((tab, idx) => {
                const data = results[idx]?.data;
                counts[tab.key] = data?.count ?? (data?.results?.length || data?.length || 0);
            });
            setTabCounts(counts);
        } catch (err) {
            console.error("Error fetching tab counts:", err);
        }
    };

    useEffect(() => {
        fetchCandidates(activeTab);
        fetchTabCounts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey);
        fetchCandidates(tabKey);
    };

    const refreshAll = () => {
        fetchCandidates(activeTab);
        fetchTabCounts();
    };

    const columns = [
        {
            title: "Candidate Name",
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) => {
                if (!text && !record.last_name) return "-";

                const firstName = text || "";
                const lastName = record.last_name || "";

                return (
                    <a
                        style={{ color: "#0e497b", cursor: "pointer" }}
                        onClick={() => setShowParticular({ show: true, cid: record.candidate })}
                    >
                       {firstName} {lastName}
                    </a>
                );
            },
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Organisation</Text>,
            dataIndex: "requisition_organisation",
            key: "requisition_organisation",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Department</Text>,
            dataIndex: "requisition_department",
            key: "requisition_department",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Designation</Text>,
            dataIndex: "requisition_designation",
            key: "requisition_designation",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Mobile No</Text>,
            dataIndex: "mobile_number",
            key: "mobile_number",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Mail</Text>,
            dataIndex: "email_id",
            key: "email_id",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Gender</Text>,
            dataIndex: "gender",
            key: "gender",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>DOB</Text>,
            dataIndex: "date_of_birth",
            key: "date_of_birth",
        },
        {
            title: <Text style={{ color: "#ffffff" }}>Converted as Employee</Text>,
            dataIndex: "convert_to_employee",
            key: "convert_to_employee",
            render: (value) => (
                <Text strong>{value ? "Converted" : "Not Converted"}</Text>
            )
        }

    ];

    // Filter out empty names if needed
    const dataSource = candidates.filter(
        (c) => c.first_name && c.first_name !== ""
    );

    return (
        <>
            {showParticular.show ? (
                <>
                    <div className="d-flex justify-content-between">
                        <div id="bread-container">
                            <a
                                className="bread-anchor"
                                id="bread-acr"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setShowParticular({ show: false, cid: 0 });
                                    refreshAll();
                                }}
                            >
                                {showParticular.show ? "← Back" : "Verified Candidates"}
                            </a>
                        </div>
                    </div>


                    <ParticularCandidates cid={showParticular.cid} />
                </>

            ) : (
                <>
                    {/* Status Tab Buttons with count badges */}
                    <div style={{ textAlign: "center", marginTop: "16px", marginBottom: "20px" }}>
                        {TABS.map((tab) => {
                            const isActive = activeTab === tab.key;
                            const count = tabCounts[tab.key] ?? 0;
                            return (
                                <Badge
                                    key={tab.key}
                                    count={count}
                                    overflowCount={999}
                                    style={{
                                        backgroundColor: isActive ? tab.activeColor : "#d9d9d9",
                                        color: isActive ? "#fff" : "#595959",
                                        fontWeight: 600,
                                        boxShadow: "none",
                                        marginRight: "25px",
                                    }}
                                >
                                    <Button
                                        type={isActive ? "primary" : "default"}
                                        onClick={() => handleTabClick(tab.key)}
                                        style={{
                                            marginRight: "10px",
                                            backgroundColor: isActive ? tab.activeColor : undefined,
                                            borderColor: isActive ? tab.activeColor : undefined,
                                            color: isActive ? "#fff" : undefined,
                                        }}
                                    >
                                        {tab.label}
                                    </Button>
                                </Badge>
                            );
                        })}
                    </div>

                    <div className="table-responsive mt-3">
                        <Table
                            columns={columns}
                            dataSource={dataSource.length > 0 ? dataSource : []}
                            rowKey={(record) => record.id}
                            bordered
                            loading={loading}
                            pagination={false}
                            scroll={{ x: "max-content" }}
                            locale={{
                                emptyText: (
                                    <Text type="secondary">No {activeTab.toLowerCase()} candidates found.</Text>
                                ),
                            }}
                            style={{
                                marginTop: 16,
                                border: "1px solid #d9d9d9",
                            }}
                            components={{
                                header: {
                                    cell: (props) => (
                                        <th
                                            {...props}
                                            style={{ backgroundColor: "#0e497b", color: "#fff" }}
                                        />
                                    ),
                                },
                            }}
                        />
                    </div>
                </>
            )}
        </>
    );
}